<ui-button
    id="interaction-export-creatives-btn"
    type="default"
    svgIcon="export"
    *ngIf="exportDropdown && exportDropdown.dropdown"
    [text]="'Export creatives (' + selectedCreatives + ')'"
    [disabled]="selectedCreatives === 0"
    [loading]="(isExporting$ | async) || false"
    [uiDropdownTarget]="exportDropdown.dropdown"></ui-button>
<export-dropdown #exportDropdown></export-dropdown>
